export const environment = {
  production: false,
  apiUrl: 'https://dev.api.suits.aeroplast.in/api',
  // apiUrl: 'http://localhost:4000/api',
  appName: 'Aero Plast',
  appSubtitle: 'SIMPLIFYING PACKAGING'
};

// npm run build:dev // this for development build
